<template>
  <div
    v-click-outside="onClickOutside"
    class="fact-finder-slider-facet"
  >
    <slider-element
      v-for="element in elements"
      :key="element.name"
      ref="sliderElement"
      :element="element"
      :group="group"
      @change="onChange"
    />
  </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3';
import { throttle } from 'throttle-debounce';

import SliderElement from './SliderElement.vue';

export default {
  name: 'FactFinderSliderFacet',
  components: {
    SliderElement,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  props: {
    group: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['change'],
  data() {
    return {
      elements: [],
    };
  },
  created() {
    // NOTE: elements will not be reactive, since it changes when a value updates, thus re-creating the slider and resetting its values
    this.elements = this.group.elements;
  },
  methods: {
    onClickOutside() {
      if (this.changeThrottle) {
        this.changeThrottle.cancel();
      }
      this.onApply();
    },
    onChange() {
      if (!this.changeThrottle) {
        this.changeThrottle = throttle(400, async () => {
          this.onApply();
        });
      }

      this.changeThrottle();
    },
    onApply() {
      const facets = this.$refs.sliderElement
        .map((sliderElement) => {
          const {
            element: { name, absoluteMinValue, absoluteMaxValue, unit },
            lower,
            upper,
          } = sliderElement;
          const { associatedFieldName } = this.group;

          const newLower = String(lower);
          const newUpper = String(upper);

          if (
            Number(lower) <= Number(absoluteMinValue) &&
            Number(upper) >= Number(absoluteMaxValue)
          ) {
            return {
              value: false,
              element: {
                name,
                associatedFieldName,
                selected: false,
                absoluteMinValue,
                absoluteMaxValue,
                unit,
              },
            };
          }

          return {
            value: true,
            element: {
              name,
              associatedFieldName,
              selected: true,
              selectedMinValue: newLower,
              selectedMaxValue: newUpper,
            },
          };
        })
        .filter((facet) => facet !== null);
      if (facets.length) {
        this.$emit('change', ...facets);
      }
    },
  },
};
</script>

<style scoped src="./fact-finder-slider-facet" />
